export const gateway = "https://jeminsurance-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://stable-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=3mfgqrjo31cpg5jijl4umqgcpk&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fjeminsurance-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "3mfgqrjo31cpg5jijl4umqgcpk";
export const BrokerPoolDomainParameter = "stable-brokers";
export const BrokerPoolParameter = "ca-central-1_smmgFhHsy";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://jeminsurance.link.wawanesalife.com";

//updated on Thu Sep 11 2025 00:55:59 GMT+0000 (Coordinated Universal Time)
